import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from './message';
import AccountService from '../../services/account.service';
import ManagerService from '../../services/manager.service';


export const getBankList = createAsyncThunk(
  "/add_bank/get_banks",
  async(thunkAPI) => {
    try {
      const response = await AccountService.getBankList();
        // console.log(response.all_banks)
      return response.all_banks;
    } catch (error) {
      return error;
    }
  }
)

export const getCountryList = createAsyncThunk(
  "/add_bank/country_list",
  async(thunkAPI) => {
    try {
      const response = await AccountService.getCountries();
      return response.data;
    } catch (error) {
      return error;
    }
  }
)

export const addBankDetails = createAsyncThunk(
  "/add_bank/",
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.addaccountDetails(payload);
      // console.log("add bank response")
      thunkAPI.dispatch(setMessage({message: response.message, status: 'True'}))
      return response.data;
    } catch (error) {
      thunkAPI.dispatch(setMessage({message: error.message, status: 'False'}))
      return error;
    }
  }
)

export const bvnVeirifcation = createAsyncThunk(
  "/verify_bvn/",
  async({bvn, dob}, thunkAPI) => {
    try {
      const payload = {bvn, dob}
      const response = await AccountService.verifyBvn(payload);
      return response;
    } catch (error) {
      return error;
    }
  }
)

// Get user profile details
export const contactlistUpload = createAsyncThunk(
  "/contact_upload/",
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.uploadContactList(payload);
      return response;
    } catch (error) {
      return error
    }
  }
)

/********    ACCOUNT  */

export const validateAccountNumber = createAsyncThunk(
  "/add_bank/validation/",
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.validateAccountNumber(payload);
        // console.log("Account verification", response)
      return response;
    } catch (error) {
      return error;
    }
  }
)

export const getAccounts = createAsyncThunk(
  "/virtual_account/",
  async(thunkAPI) => {
    try {
      const response = await AccountService.getVirtualAccounts();
      // console.log("accounts", response)
      return response.data;
    } catch (error) {
      return error;
    }
  }
)

export const getMemberAccounts = createAsyncThunk(
  "/members/virtual_accounts/",
  async(thunkAPI) => {
    try {
      const response = await ManagerService.getVirtualAccounts();
      return response;
    } catch (error) {
      return error;
    }
  }
)

export const createVirtualAccount = createAsyncThunk(
    '/virtual_account/',
    async(payload, thunkAPI) => {
        try {
            const response = await AccountService.createVirtualAccount(payload)
            if(response.success) {
              thunkAPI.dispatch(setMessage({message: response.message, status: 'True'}))
            }
            else {
              thunkAPI.dispatch(setMessage({message: response.message, status: 'False'}))
            }
            return response
          } catch (error) {
            thunkAPI.dispatch(setMessage({message: error.message, status: 'False'}))
            return error
        }
    }
)

/********    PAYCODES  */

export const createPaycode = createAsyncThunk(
  '/create_paycode/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.createPaycode(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const createQrPaycode = createAsyncThunk(
  '/create_paycode/',
  async(payload, thunkAPI) => {
      try {
        const response = await AccountService.createQrPaycode(payload)
        return response
      } catch (error) {
        return error
      }
  }
)

export const chargeBusinessRegistration = createAsyncThunk(
  '/create_paycode/',
  async(payload, thunkAPI) => {
      try {
        const response = await AccountService.chargeAccount(payload)
        return response
      } catch (error) {
        return error
      }
  }
)

export const createBulkPaycode = createAsyncThunk(
  '/create_bulk_paycode/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.bulkCreatePaycode(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const applyPayCode = createAsyncThunk(
  '/paycode/redeem/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.claimPaycode(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const confirmPaycode = createAsyncThunk(
  '/confirm_paycode/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.confirmPaycode(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const claimPaycode = createAsyncThunk(
  '/claim_paycode/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.claimPaycode(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const claimPaycodeQr = createAsyncThunk(
  '/api-v1/claim_paycode/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.claimPaycodeWithQr(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const checkBalance = createAsyncThunk(
  '/paycode_balance/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.checkPaycodeBalance(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const getPaycodes = createAsyncThunk(
  '/paycodes/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.getMerchantPaycode(payload)
          // console.log("Paycodes", response)
          return response
      } catch (error) {
        return error
      }
  }
)

/********    TRANSACTIONS  */

export const getFaasPaycodeDetails = createAsyncThunk(
  '/fase_pay/?paycode_details/',
  async(paycode, thunkAPI) => {
    try {
      const response = await AccountService.faasPayCodeDetails(paycode)
      return response
    }
    catch (error){ 
      thunkAPI.dispatch(setMessage({message: error.message, status: 'False'}))
      return error
    }
})

export const getTransactionHistory = createAsyncThunk(
  '/transaction_history/',
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.transactionHistory(payload)
      return response
    }
    catch (error){ 
      thunkAPI.dispatch(setMessage({message: error.message, status: 'False'}))
      return error
    }
})

export const getFasepayTransactionHistory = createAsyncThunk(
  '/transaction_history/',
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.fasepayTransactions(payload)
      // console.log("transactions", response)
      return response
    }
    catch (error){ 
      thunkAPI.dispatch(setMessage({message: error.message, status: 'False'}))
      return error
    }
})

export const getTransactionReports = createAsyncThunk(
  '/transaction_history/',
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.generateReport(payload)
      // console.log("transactions", response)
      return response
    }
    catch (error){ 
      thunkAPI.dispatch(setMessage({message: error.message, status: 'False'}))
      return error
    }
})

export const getTransferCharges = createAsyncThunk(
  '/transaction_charges/',
  async(thunkAPI) => {
      try {
        const response = await AccountService.getCharges()
        return response
      } catch (error) {
        return error
      }
  }
)

export const getAnalytics = createAsyncThunk(
  '/transaction_charges/',
  async(params, thunkAPI) => {
      try {
        const response = await AccountService.analytics(params)
        return response
      } catch (error) {
        return error
      }
  }
)

export const inflowAnalytics = createAsyncThunk(
  '/inflow_data/',
  async(_, thunkAPI) => {
      try {
        const response = await AccountService.getInflowData()
        return response
      } catch (error) {
        return error
      }
  }
)

/********    INVOICES  */
export const fetchInvoices = createAsyncThunk(
  '/merchant_invoice/',
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.getInvoices(payload)
      // console.log("Invoices", response)
      return response
    }
    catch (error){ 
      return error
    }
})

export const getInvoice = createAsyncThunk(
  '/merchant_invoice/',
  async(reference, thunkAPI) => {
    try {
      const response = await AccountService.getInvoicesByRef(reference)
      return response
    }
    catch (error){ 
      return error
    }
})

export const addInvoice = createAsyncThunk(
  '/merchant_invoice/',
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.createInvoice(payload)
      return response
    }
    catch (error){ 
      return error
    }
  })

export const payInvoice = createAsyncThunk(
  '/pay_invoice/',
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.invoicePayment(payload)
      return response
    }
    catch (error){ 
      return error
    }
  })

export const invoiceVerification = createAsyncThunk(
  '/verify_invoice/',
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.verifyInvoice(payload)
      return response
    }
    catch (error){ 
      return error
    }
  })

export const getAnnouncements = createAsyncThunk(
  '/announcements/',
  async(thunkAPI) => {
    try {
      const response = await AccountService.announcements()
      // console.log("Verify", response)
      return response
    }
    catch (error){ 
      return error
    }
  })

  export const updateInvoiceDetails = createAsyncThunk(
    '/update_invoice/:id/',
    async(payload, thunkAPI) => {
      try {
        const response = await AccountService.updateInvoiceData(payload)
        return response
      }
      catch (error){ 
        return error
      }
    })

  export const deleteInvoiceRecord = createAsyncThunk(
    '/update_invoice/:id/',
    async(reference, thunkAPI) => {
      try {
        const response = await AccountService.deleteInvoiceData(reference)
        return response
      }
      catch (error){ 
        return error
      }
    })
  
  /****** VOUCHERS */
  export const getUserVouchers = createAsyncThunk(
    '/merchant_invoice/',
    async(payload, thunkAPI) => {
      try {
        const response = await AccountService.getVouchers(payload)
        // console.log("Vouchers", response)
        return response
      }
      catch (error){ 
        thunkAPI.dispatch(setMessage({message: error.message, status: 'False'}))
        return error
      }
  })


  /****** FasePay */

  export const payWithFase = createAsyncThunk(
    '/fase_pay/',
    async(payload, thunkAPI) => {
      try {
        const response = await AccountService.fasePay(payload)
        return response
      }
      catch (error){ 
        return error
      }
  })

  export const fxExchange = createAsyncThunk(
    '/fase_pay/',
    async(payload) => {
      try {
        const response = await AccountService.sellFx(payload)
        return response
      }
      catch (error){ 
        return error
      }
  })

  export const getRates = createAsyncThunk(
    '/sell_fx/',
    async(_,) => {
      try {
        const response = await AccountService.getFxRates()
        return response
      }
      catch (error){ 
        return error
      }
  })

  /******** LOYALTY VOUCHERS  */

export const createLoyaltyPaycode = createAsyncThunk(
  '/create_paycode/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.createLoyaltyPaycode(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const createBulkLoyaltyVoucher = createAsyncThunk(
  '/loyalty_voucher_bulk_create/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.createBulkLoyaltyVoucher(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const applyLoyaltyPayCode = createAsyncThunk(
  '/paycode/redeem/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.claimLoyaltyPaycode(payload)
          thunkAPI.dispatch(setMessage({message: response.message, status: 'True'}))
          return response
      } catch (error) {
        thunkAPI.dispatch(setMessage({message: error.message, status: 'False'}))
        return error
      }
  }
)

export const confirmLoyaltyPaycode = createAsyncThunk(
  '/confirm_paycode/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.confirmLoyaltyPaycode(payload)
          // console.log(response)
          return response
      } catch (error) {
        thunkAPI.dispatch(setMessage({message: error.message, status: 'False'}))
        return error
      }
  }
)

export const claimLoyaltyPaycode = createAsyncThunk(
  '/claim_paycode/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.claimLoyaltyPaycode(payload)
          thunkAPI.dispatch(setMessage({message: response.message, status: 'True'}))
          // console.log(response)
          return response
      } catch (error) {
        thunkAPI.dispatch(setMessage({message: error.message, status: 'False'}))
        return error
      }
  }
)

export const checkLoyaltyBalance = createAsyncThunk(
  '/paycode_balance/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.checkLoyaltyPaycodeBalance(payload)
          return response
      } catch (error) {
        thunkAPI.dispatch(setMessage({message: error.message, status: 'False'}))
        return error
      }
  }
)

export const getLoyaltyPaycodes = createAsyncThunk(
  '/paycodes/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.getLoyaltyPaycodes(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const getLoyaltyPaycodeHistory = createAsyncThunk(
  '/paycodes/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.getLoyaltyPaycodeHistory(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const loyaltyVoucherTopup = createAsyncThunk(
  '/loyalty_voucher_topup',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.topupVoucher(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const getTaxCalculations = createAsyncThunk(
  '/paycodes/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.getTaxCalculators(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const getOTP = createAsyncThunk(
  '/loyalty_voucher_verification/',
  async(user_type, thunkAPI) => {
      try {
          const response = await AccountService.sendOtp(user_type)
          return response
      } catch (error) {
        return error
      }
  }
)

export const requestNewOTP = createAsyncThunk(
  '/request_otp/',
  async(_, thunkAPI) => {
      try {
          const response = await AccountService.requestOTP()
          return response
      } catch (error) {
        return error
      }
  }
)

export const getVoucherDiscount = createAsyncThunk(
  '/loyalty_voucher_verification/',
  async(_, thunkAPI) => {
      try {
          const response = await AccountService.getVoucherDiscount()
          return response
      } catch (error) {
        return error
      }
  }
)

export const configureVoucherDiscount = createAsyncThunk(
  '/loyalty_voucher_verification/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.setVoucherDiscount(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

// **** PETTY CASH *** \\
export const getPettyWallet = createAsyncThunk(
  '/petty_cash_wallet/',
  async(_, thunkAPI) => {
      try {
          const response = await AccountService.getPettyCashWalletDetails()
          return response
      } catch (error) {
        return error
      }
  }
)

export const addPettyBeneficiary = createAsyncThunk(
  '/petty_cash_beneficiary/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.createPettyCashBeneficary(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const getPettyBeneficaries = createAsyncThunk(
  '/petty_cash_beneficiaries/',
  async(_, thunkAPI) => {
      try {
          const response = await AccountService.getPettyCashBeneficaries()
          return response
      } catch (error) {
        return error
      }
  }
)

export const payPettyBeneficiary = createAsyncThunk(
  '/pay_beneficiary/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.payPettyCashBeneficary(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const managePettyRequest = createAsyncThunk(
  '/petty_cash_request/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.managePettyCashRequest(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const getPettyRequest = createAsyncThunk(
  '/petty_cash_request/',
  async(_, thunkAPI) => {
      try {
          const response = await AccountService.getPettyCashRequests()
          return response
      } catch (error) {
        return error
      }
  }
)

export const creditPettyWallet = createAsyncThunk(
  '/petty_cash_wallet/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.creditPettyCashWallet(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const getPettyWalletLog = createAsyncThunk(
  '/petty_cash_wallet_log/',
  async(payload, thunkAPI) => {
      try {
          const response = await AccountService.getPettyCashWalletLogs(payload)
          return response
      } catch (error) {
        return error
      }
  }
)

export const downloadPettyCashLog = createAsyncThunk(
  '/petty_cash_wallet_log/',
  async(_, thunkAPI) => {
      try {
        return await AccountService.downloadPettyCashLog()
      } catch (error) {
        return error
      }
  }
)

// **** SALES FORCE *** \
export const getSalesforceAgents = createAsyncThunk(
  '/merchant/sales_forece/',
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.getSalesForeceList(payload)
      return response
    }
    catch (error){ 
      return error
    }
})

export const getSalesforceTransactions = createAsyncThunk(
  '/merchant/sales_forece_transaction/',
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.getSalesForeceTransactionList(payload)
      return response
    }
    catch (error){ 
      return error
    }
})

export const getSalesforceTransactionAnalytics = createAsyncThunk(
  '/merchant/sales_forece/transaction_history_analytics/',
  async(_, thunkAPI) => {
    try {
      const response = await AccountService.getSalesForceAnalytics()
      return response
    }
    catch (error){ 
      return error
    }
})

export const getSalesforceDetails = createAsyncThunk(
  '/merchant/sales_forece/:id/',
  async(id, thunkAPI) => {
    try {
      const response = await AccountService.getSalesForeceById(id)
      return response
    }
    catch (error){ 
      return error
    }
})

export const withdrawSalesforceBalance = createAsyncThunk(
  '/sales_forece/withdraw_sales_force_balance/',
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.withdrawSalesForeceBalance(payload)
      return response
    }
    catch (error){ 
      return error
    }
})

export const PaySalesforceSalary = createAsyncThunk(
  '/sales-force/pay_salary/',
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.paySalesForeceSalaries(payload)
      return response
    }
    catch (error){ 
      return error
    }
})

export const blockUnblockSalesforceAgent = createAsyncThunk(
  '/sales-force/block_sales_force/',
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.manageSalesForeceAgent(payload)
      return response
    }
    catch (error){ 
      return error
    }
})

export const getMemberSalesforceAgents = createAsyncThunk(
  '/member/sales_forece/',
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.getMemberSalesForeceList(payload)
      return response
    }
    catch (error){ 
      return error
    }
})

export const getMemberSalesforceTransactions = createAsyncThunk(
  '/member/sales_forece_transaction/',
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.getMemberSalesForeceTransactionList(payload)
      return response
    }
    catch (error){ 
      return error
    }
})

export const getMemberSalesforceTransactionAnalytics = createAsyncThunk(
  '/member/sales_forece/transaction_history_analytics/',
  async(_, thunkAPI) => {
    try {
      const response = await AccountService.getMemberSalesForceAnalytics()
      return response
    }
    catch (error){ 
      return error
    }
})

export const getMemberSalesforceDetails = createAsyncThunk(
  '/member/sales_forece/:id/',
  async(id, thunkAPI) => {
    try {
      const response = await AccountService.getMemberSalesForeceById(id)
      return response
    }
    catch (error){ 
      return error
    }
})

export const getAllowedMenuItems = createAsyncThunk(
  '/allowed_features/',
  async(_, thunkAPI) => {
    try {
      const response = await AccountService.getAllowedFeatures()
      return response
    }
    catch (error){ 
      return error
    }
})

//********    INTERNATIONAL PAYMENTS  */
export const sendPaymentRequest = createAsyncThunk(
  '/international_payments/',
  async(payload, thunkAPI) => {
    try {
      const response = await AccountService.sendPaymentRequest(payload)
      return response
    }
    catch (error){ 
      return error
    }
})

export const verifyPayment = createAsyncThunk(
  '/international_payments_status/',
  async(merchantId, thunkAPI) => {
    try {
      const response = await AccountService.verifyPaymentRequest(merchantId)
      return response
    }
    catch (error){ 
      return error
    }
})

export const getBanks = createAsyncThunk(
  '/add_bank/',
  async(currency, thunkAPI) => {
    try {
      const response = await AccountService.getBanks(currency)
      return response
    }
    catch (error){ 
      return error
    }
})


const accountSlice = createSlice({
  name: "account",
  initialState: {
    is_account_created: false,
    accounts: null
  },
  reducers: {
    hasError(state, action) {
      state.isLoading = false
      state.error = action.payload
    },
    startLoading(state) {
      state.isLoading = true
    },
    setUser(state, action) {
      state.isLoading = false
      state.user = action.payload
    },
    setToken(state, action) {
      localStorage.setItem("token", action.payload); 
    },
    signOut(state) {
      state.isLoggedIn = false
      state.user = null
    },

  },
  extraReducers: {
    [createVirtualAccount.fulfilled]: (state, action) => {
    },
    [getAccounts.fulfilled]: (state, action) => {
      if(action.payload?.data) {
        state.accounts = action.payload.data
      }
    },
    [getMemberAccounts.fulfilled]: (state, action) => {
      if(action.payload?.data) {
        state.accounts = action.payload?.data
      }
    },
  }
})

const { reducer } = accountSlice
export default reducer;